/**
 * Check if value is a "regular" js object.
 * This is a simlified version of lodash `isPlainObject`, without checking for every corner case.
 * @example
 *
 * isObject(null) === false
 * isObject([]) === false
 * isObject({}) === true
 */

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function isObject(val: any): boolean {
  return (
    val !== null &&
    typeof val === 'object' &&
    val.toString() === '[object Object]'
  )
}
